import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-advertisements',
  templateUrl: './advertisements.component.html',
  styleUrls: ['./advertisements.component.css'],
})
export class AdvertisementsComponent implements OnInit {
  public advertisements: any[] = [];
  spinnerType = SPINNER.circle;
  public user: any;
  constructor(
    private ngxService: NgxUiLoaderService,
    public router: Router,
    public authenticationService: AuthenticationService,
    private modalService : NgbModal
  ) {}
  ngOnInit(): void {
    this.getUserProfile();
    this.getAdvertisements();
  }
  public getAdvertisements(): void {
    this.ngxService.start();
    this.authenticationService.getAdvertisement().subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.advertisements = response?.data || [];
      },
      (error) => {
        this.ngxService.stop();
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }
  delete(id) {
    var result = confirm('Are you sure you want to delete your Advertisement?');
    if (result) {
      this.authenticationService.deleteAds(id).subscribe(
        (response: any) => {
          this.ngxService.stop();
          this.getAdvertisements();
        },
        (error) => {
          this.ngxService.stop();
          if (error) {
            Swal.fire('Error', error.error.message, 'error');
          }
        }
      );
    }
  }
  checkImage(usr) {
    if (usr) {
      let pathArray = usr.split('/');
      let protocol = pathArray[0];
      let host = pathArray[2];
      let url = protocol + '//' + host + '/';
      if (url == environment.basePath) {
        return usr;
      } else {
        return environment.basePath + usr;
      }
    }
  }

  onImgError(event: Event, fallbackSrc: string = 'assets/imageplaceholder.jpeg') {
    const img = event?.target as HTMLImageElement | null;
    if (!img) return;
    if (img.getAttribute('data-fallback-applied') === '1') return;
    img.setAttribute('data-fallback-applied', '1');
    img.src = fallbackSrc;
  }
  redirect(type) {
    if (type == 1) {
      if (this.user.hasSubscription == true) {
        this.router.navigate(['/add-advertisement']);
      } else {
        Swal.fire('Error', 'Please subscribe base plan.', 'error');
      }
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
  getUserProfile(): void {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.user = response.data;
        console.log(this.user, 'testing1111');
        // Swal.fire()
      },
      (error) => {
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }

  createAds(content: any) {    
    if (this.user?.subscriptionPlanType) {
      this.router.navigate(['/add-advertisement']);
    }
    else {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    }
  }




  goToSubscribe() {
    this.router.navigate(
      ['/mysubscration'],
      { queryParams: { isSub: 'true' } }
    );
    this.modalService.dismissAll()
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
    this.modalService.dismissAll()
  }

}
